import { useState } from 'react';

import { Paperclip } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';

import { Popover, PopoverTrigger, PopoverContent } from '@/new/components/shadcn/popover';

interface ChildFile {
  id: string;
  name: string;
  doc?: {
    id: string;
    fileId?: string;
  };
}

interface ChildDocumentPopoverProps {
  children: React.ReactNode;
  childFiles: ChildFile[];
}

export function ChildDocumentPopover({ children, childFiles }: ChildDocumentPopoverProps) {
  const { matterId, subsetId } = useParams();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent sideOffset={8} align="start">
        <div className="mb-3 flex items-center gap-2">
          <Paperclip size={14} className="text-green-600" />
          <h3 className="text-sm font-semibold">Attachments</h3>
        </div>

        <div className="max-h-48 space-y-1 overflow-y-auto">
          {childFiles.map((childFile) => (
            <Link
              key={childFile.doc?.id}
              to={`/matters/${matterId}/subsets/${subsetId}/docs/${childFile.doc?.id}`}
              className="block w-full truncate text-left text-sm text-blue-600 underline hover:text-blue-700"
            >
              {childFile.name}
            </Link>
          ))}

          {childFiles.length === 0 && (
            <div className="py-4 text-center text-sm text-gray-500">No attachments found</div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
